<a *ngIf="assetId" routerLink="/asset/{{assetId}}">
    {{ assetId }}
</a>